package com.macrofocus.eflux.ui.mui.utilities

import com.macrofocus.eflux.Languages
import com.macrofocus.eflux.ui.AppPreference
import com.macrofocus.eflux.ui.PaletteType
import i18next.I18next
import org.w3c.dom.Storage
import org.w3c.dom.get
import org.w3c.dom.set
import kotlin.reflect.KProperty

class BrowserAppPreference(
    localStorage: Storage,
    i18next: I18next,
) : AppPreference {
    override val lang get() = language ?: Languages.ENGLISH
    val themeType get() = paletteType

    override fun setLanguage(lang: Languages) { language = lang }
    fun setThemeType(type: PaletteType) { paletteType = type }

    private var language by i18next
    private var paletteType by localStorage

    data class State(
        val lang: Languages,
        val themeType: PaletteType,
    ) {
        constructor(preference: BrowserAppPreference) : this(
            lang = preference.lang,
            themeType = preference.themeType ?: PaletteType.light,
        )
    }
}

private operator fun Storage.getValue(
    thisRef: BrowserAppPreference,
    property: KProperty<*>,
) = get(property.name)?.let { PaletteType.valueOf(it) }

private operator fun Storage.setValue(
    thisRef: BrowserAppPreference,
    property: KProperty<*>,
    value: PaletteType?,
) { if (value == null) removeItem(property.name) else set(property.name, value.name) }

private operator fun I18next.getValue(
    thisRef: BrowserAppPreference,
    property: KProperty<*>,
) = Languages.valueOfCode(language)

private operator fun I18next.setValue(
    thisRef: BrowserAppPreference,
    property: KProperty<*>,
    value: Languages?,
) { value?.code?.let(this::changeLanguage) }

//@Suppress("FunctionName")
//internal fun AppPreferenceModule(i18next: I18next) = module {
//    single<AppPreference> { BrowserAppPreference(localStorage, i18next) }
//}
